import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: 'Verticals',
  value: '5+'
}, {
  label: 'Workflows Automated',
  value: '100+'
}, {
  label: 'Security',
  value: 'Enterprise-Grade'
}, {
  label: 'Approach',
  value: 'Human-in-the-Loop'
}];
export function TrustSection() {
  return <section className="py-32 bg-[#050505] relative z-10 border-t border-white/5" data-id="element-499">
      <div className="max-w-7xl mx-auto px-6" data-id="element-500">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-501">
          <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight" data-id="element-502">
            Why Aijentik.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-32" data-id="element-503">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-504">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-505">
              Built for Depth
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-506">
              Every agent is designed around real industry workflows and
              operational nuances. Not generic automation.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-507">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-508">
              Implementation-Ready
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-509">
              Production-grade from day one, built to integrate, govern, and
              scale securely within your environment.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-510">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-511">
              Operational Context
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-512">
              Understands the rules that matter, compliance, and SLAs. It
              doesn't just generate text; it executes business logic.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 pt-16 border-t border-white/5" data-id="element-513">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-514">
              <div className="text-4xl md:text-5xl font-display text-white mb-4 tracking-tight" data-id="element-515">
                {stat.value}
              </div>
              <div className="text-xs text-brand-orange font-medium uppercase tracking-widest" data-id="element-516">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}